import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";
import { Link } from "react-router-dom";
import WineCard from "../components/WineCard";
// import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/styles.css"; // <-- assure-toi du bon chemin

export default function Home() {
  const [wines, setWines] = useState([]);
  const [cats, setCats] = useState([]);
  const [loadingWines, setLoadingWines] = useState(true);
  const [loadingCats, setLoadingCats] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchWines = async () => {
      try {
        const qSnap = await getDocs(collection(db, "winesek"));
        const list = qSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setWines(list);
      } catch (err) {
        console.error(err);
        setError("Erreur lors du chargement des vins.");
      } finally {
        setLoadingWines(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const snap = await getDocs(collection(db, "categoriesWine"));
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setCats(list);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingCats(false);
      }
    };

    fetchWines();
    fetchCategories();
  }, []);

  return (
    <div className="container py-5">
      {/* Section catégories */}
      <section className="mb-5">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h2 className="h5 m-0">Catégories</h2>
          {/* Lien vers une page “toutes catégories” si tu en crées une */}
          {/* <Link to="/categories" className="btn btn-sm btn-outline-dark">Tout voir</Link> */}
        </div>

        {loadingCats ? (
          <p>Chargement des catégories…</p>
        ) : cats.length === 0 ? (
          <div className="text-muted">Aucune catégorie enregistrée.</div>
        ) : (
          <div className="row g-3">
            {cats.map((c) => (
              <div key={c.id} className="col-6 col-sm-4 col-md-3 col-lg-2">
                <Link to={`/category/${encodeURIComponent(c.id)}`} className="cat-card d-block text-decoration-none">
                  <div className="cat-thumb">
                    <img
                      src={c.imageUrl || "/placeholder.png"}
                      alt={c.name || "Catégorie"}
                      onError={(e) => (e.currentTarget.src = "/placeholder.png")}
                      loading="lazy"
                    />
                  </div>
                  <div className="cat-title">{(c.name || "").toUpperCase()}</div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Section vins */}
      <h1 className="mb-4">Nos produits</h1>
      {loadingWines && <p>Chargement des vins...</p>}
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="row">
        {wines.map((wine) => (
          <div key={wine.id} className="col-6 col-md-4 col-lg-3 mb-4">
            <WineCard wine={wine} />
          </div>
        ))}
      </div>
    </div>
  );
}
